import React, { useEffect, useState } from "react";
import { Text, StyleSheet, ActivityIndicator, FlatList } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { serviceResponse } from "../../../services/common";
import { getResources, Resource, toggleResourceStatus } from "../../../services/Resource";
import { RootState } from "../../../services/store/app";
import { setLocalResources } from "../../../services/store/common";
import { View } from "../../Themed";
import SettingsHeader from "../Header";
import ResourceItem from "./Item";

interface Props {
    onCreate: () => void;
}

export default function ResourceView({ onCreate }: Props) {
    const dispatch = useDispatch();
    const commonStore = useSelector((state: RootState) => state.commonReducer);
    const [init, setInit] = useState(false);
    const [resources, setResources] = useState<Resource[]>([]);

    useEffect(() => {
        setResources(commonStore.resources);
        setInit(true);
    }, [commonStore]);

    const unsubscribe = async () => {
        const req = await getResources();

        if (req === serviceResponse.systemError) {
            return alert("Something went wrong, please try it again reloading");
        }

        if (req === serviceResponse.notContent) {
            return dispatch(setLocalResources([]));
        }

        const data = req as Resource[];
        dispatch(setLocalResources(data));
    }

    useEffect(() => {
        unsubscribe();
    }, []);

    const toggleStatus = async ({ id, isActive }: Resource) => {
        const toggle = await toggleResourceStatus(id, isActive);

        if (toggle === serviceResponse.emptyFields || toggle === serviceResponse.systemError) {
            return alert("Something went wrong, please try it again");
        }

        await unsubscribe();
    }


    if (!init) {
        return <View style={styles.container}>
            <SettingsHeader title="Positions" onCreate={onCreate} />
            <ActivityIndicator size="large" />
        </View>
    }

    if (!resources.length) {
        return <View style={styles.container}>
            <SettingsHeader title="Positions" onCreate={onCreate} />

            <Text style={{ marginHorizontal: 'auto', marginTop: 15, fontSize: 14, fontWeight: '400' }}>
                Without resources
            </Text>
        </View>
    }

    return <View style={styles.container}>
        <SettingsHeader title="Resources" onCreate={onCreate} />

        <FlatList
            data={resources}
            style={{ flex: 1 }}
            // ListEmptyComponent={
            //     <View>
            //         <Text style={{ marginHorizontal: 'auto', marginTop: 15, fontSize: 14, fontWeight: '400' }}>Without results</Text>
            //     </View>
            // }
            renderItem={({ item }) => <ResourceItem resource={item} key={item.id} onPressToggle={toggleStatus} />}
        />
    </View>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },

});